import { render, staticRenderFns } from "./BrandEditDialog.vue?vue&type=template&id=0d90cd86&"
import script from "./BrandEditDialog.vue?vue&type=script&lang=js&"
export * from "./BrandEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports